// extracted by mini-css-extract-plugin
export default {"deleteMain":"successDelete_deleteMain__LO4is"};